function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './TopPicks.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get, canUseDOM, getDictionaryItem, getPageThemeColors, getColorByTheme } from '../../utils';
import { commonStyles, eventStyle, poiStyle, articleStyle, curatorStyle, stylesRTL, stylesLTR } from '../Listing/Listing';
import getListing from '../../utils/getListing';
import { loadMoreButtonStylesLtr } from '../DynamicListingComponent/DynamicListingComponent';
import { POIBlock } from './../34_POIs/POIs';
import { ArticleBlock } from '../02_Articles/Articles';
import EventBlock from "../15_Events/components/EventBlock";
import { ItenaryBlock, commonStyles as itemStyles } from '../26_Itineraries/Itineraries';
import { commonStyles as curatorltrStyles, rtlStyles as curatorRtlStyles } from '../10_Curators/Curators';
import { commonStyles as filterStyle } from '../Listing/Switch';
import LoadMore from '../DynamicListingComponent/LoadMore';
import heartLine from '../../resources/icons/heart-line.svg';
import { convertToAnalyticObject } from '../../utils/analytics';
import { RestaurantsCard } from '../atoms/RestaurantsCard/RestaurantsCard';
import useProfile from '../../utils/hooks/useProfile';
export const LOCAL_STORAGE_TOPPICKS_NAME = 'top-picks';
var EСheckboxLabelTypes = /*#__PURE__*/function (EСheckboxLabelTypes) {
  EСheckboxLabelTypes["Article"] = "Article";
  EСheckboxLabelTypes["POI"] = "POI";
  EСheckboxLabelTypes["Event"] = "Event";
  EСheckboxLabelTypes["Itineraries"] = "Itineraries";
  EСheckboxLabelTypes["Restaurant"] = "Restaurant";
  return EСheckboxLabelTypes;
}(EСheckboxLabelTypes || {});
const CheckBox = _ref => {
  let {
    index,
    item,
    label,
    checkboxRef,
    setFilter
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "g-checkbox__item"
  }, /*#__PURE__*/React.createElement("input", {
    value: item,
    type: "checkbox",
    className: "fp__checkbox",
    id: `gct1-${index}`,
    name: "gct1",
    onChange: e => {
      const checkboxLength = checkboxRef.current.querySelectorAll('.fp__checkbox').length - checkboxRef.current.querySelectorAll('.fp__checkbox:checked').length;
      if (checkboxLength !== 0) {
        setFilter(e.target.value, e.target.checked);
      } else {
        e.target.checked = false;
      }
    },
    title: label
  }), /*#__PURE__*/React.createElement("label", {
    className: "body-small g-checkbox__label",
    htmlFor: `gct1-${index}`
  }, label));
};
const TopPicks = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const currentLang = get(sitecoreContext, 'language');
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const userProfile = useProfile();
  const [hits, setHits] = React.useState();
  const [facets, setFacets] = React.useState();
  const [nbHits, setnbHits] = React.useState(0);
  const [nbPages, setnbPages] = React.useState(0);
  const [page, setpage] = React.useState(0);
  const [result, setResult] = React.useState();
  const [emptyError, setemptyError] = React.useState(false);
  const [stateFilters, setstateFilters] = React.useState({});
  const dictionary = get(fields, 'data.dictionary');
  const curatorPick = getDictionaryItem(dictionary, 'Curatorspick');
  const byCopy = getDictionaryItem(dictionary, 'By');
  const MinRead = getDictionaryItem(dictionary, 'MinRead');
  const day = getDictionaryItem(dictionary, 'day') || 'day';
  const days = getDictionaryItem(dictionary, 'days') || 'days';
  const EventFilterTitle = getDictionaryItem(dictionary, 'EventFilterTitle');
  const ItineraryFilterTitle = getDictionaryItem(dictionary, 'ItineraryFilterTitle');
  const PoiFilterTitle = getDictionaryItem(dictionary, 'PoiFilterTitle');
  const ArticleFilterTitle = getDictionaryItem(dictionary, 'article field title ');
  const RestaurantFilterTitle = getDictionaryItem(dictionary, 'RestaurantFilterTitle');
  const LoadMoreCopy = getDictionaryItem(dictionary, 'LoadMore');
  const eventCopy = getDictionaryItem(dictionary, 'event');
  const poiCopy = getDictionaryItem(dictionary, 'poi');
  const itineraryCopy = getDictionaryItem(dictionary, 'itinerary');
  const articleCopy = getDictionaryItem(dictionary, 'article');
  const errorMessage = getDictionaryItem(dictionary, 'AddItemsToYourTopPicks');
  const removedMessage = getDictionaryItem(dictionary, 'HasBeenRemoved');
  const YourTopPicksTitle = getDictionaryItem(dictionary, 'YourTopPicksTitle');
  const indexName = get(params, 'SearchIndex');
  const SearchCount = get(params, 'SearchCount') || 12;
  const countryItems = get(fields, 'data.countries.countryValues') || [];
  const [removedItemType, setremovedItemType] = React.useState('');
  const [favButtonState, setfavButtonState] = React.useState('');
  const [objectIdState, setobjectIdState] = React.useState([]);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const checkboxRef = /*#__PURE__*/React.createRef();
  const filterRef = React.useRef();
  let hasItenaryFilter = false;
  ///let timer: any;
  //  let parsedId: any;
  const [parsedId, setparsedId] = React.useState('');
  const [timer, settimer] = React.useState('');
  const viewedNofMLabel = `${getDictionaryItem(dictionary, 'YouHaveViewed')} {#loadedHits#} ${getDictionaryItem(dictionary, 'Of')} {#nbHits#} ${getDictionaryItem(dictionary, 'Items')}`;
  const checkboxLabelMap = {
    "Article": ArticleFilterTitle,
    "POI": PoiFilterTitle,
    "Event": EventFilterTitle,
    "Itineraries": ItineraryFilterTitle,
    "Restaurant": RestaurantFilterTitle
  };
  let types = ['type:Article', 'type:POI', 'type:Event', 'type:Itineraries', 'type:Restaurant'];
  const [filterTypes, setfilterTypes] = React.useState(types);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const [overlayButton, setOverlayButton] = React.useState(false);
  const RemoveButtonOvelray = () => /*#__PURE__*/React.createElement("div", {
    className: `${overlayButton ? 'remove-button-overlay remove-button-overlay--active' : 'remove-button-overlay'}`,
    onClick: () => {
      setOverlayButton(false);
      removeItem(parsedId);
      clearTimeout(timer);
    }
  }, rtl ? `${removedMessage} ${removedItemType}` : `${removedItemType} ${removedMessage}`);
  // let objectId: any=[];
  let items;
  // let objectId: any = [];
  // if (canUseDOM) {
  //   if (localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) !== null) {
  //     items = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) as any);
  //   }
  // }

  // const objectId =
  //   get(items, 'list', []).map((item: any) => {
  //     return `objectID:${item.itemId.split('-').join('')}`;
  //   }) || [];

  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  React.useEffect(() => {
    if (canUseDOM) {
      if (localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) !== null) {
        items = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME));
      }
    }
    const objectId = get(items, 'list', []).map(item => {
      return `objectID:${item && item.itemId && item.itemId.split('-').join('')}`;
    }) || [];
    setobjectIdState(objectId);
    if (objectId.length === 0) {
      setemptyError(true);
      return;
    }
    // let itemFilters: any;

    let itemFilters = _objectSpread(_objectSpread({}, stateFilters), {}, {
      facets: ['type'],
      facetFilters: [types, [...objectId]],
      hitsPerPage: SearchCount
    });
    if (Object.keys(stateFilters).length === 0) {
      itemFilters = _objectSpread(_objectSpread({}, stateFilters), {}, {
        facets: ['type'],
        facetFilters: [types, [...objectId]],
        hitsPerPage: SearchCount
      });
    } else {
      itemFilters = _objectSpread({}, stateFilters);
      itemFilters = _objectSpread(_objectSpread({}, stateFilters), {}, {
        facets: ['type'],
        facetFilters: [stateFilters.facetFilters[0], [...objectId]],
        hitsPerPage: SearchCount
      });
    }
    getListing(indexName, itemFilters, algoliaSettings).then(response => {
      setHits(response.hits);
      setnbPages(response.nbPages);
      setnbHits(response.nbHits);
      setpage(1);
      setResult(response);
      setFacets(response.facets);
      setstateFilters(itemFilters);
      if (response.hits.length === 0) {
        setemptyError(true);
      }
      // setTimeout(function() {
      //   if (canUseDOM) {
      //     window.onscroll = () => {};
      //   }
      // }, 100);
    });
  }, [favButtonState]);
  const setFilter = (value, isChecked) => {
    let filteredAry = [];
    const checkboxes = checkboxRef.current.querySelectorAll('.fp__checkbox');
    for (let index = 0; index < checkboxes.length; index++) {
      const element = checkboxes[index];
      if (element.checked) {
        filteredAry.push('type:' + element.value);
      }
    }
    let filterTypes = types.filter(val => !filteredAry.includes(val));
    // filterTypes
    setfilterTypes(filterTypes);
    if (canUseDOM) {
      if (localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) !== null) {
        items = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME));
      }
    }
    const objectId = get(items, 'list', []).map(item => {
      return `objectID:${item && item.itemId && item.itemId.split('-').join('')}`;
    }) || [];
    //setobjectIdState(objectId);
    // if (objectId.length === 0) {
    //   setemptyError(true);
    //   return;
    // }
    let itemFilters = _objectSpread(_objectSpread({}, stateFilters), {}, {
      facets: ['type'],
      facetFilters: [[...filterTypes], [...objectId]]
    });
    getListing(indexName, itemFilters, algoliaSettings).then(response => {
      setHits(response.hits);
      setnbPages(response.nbPages);
      setnbHits(response.nbHits);
      setResult(response);
      setpage(1);
      setstateFilters(itemFilters);
    });
    // }
  };
  const loadMore = () => {
    // if (canUseDOM) {

    //   var x = window.scrollX;
    //   var y = window.scrollY;
    //   const scrollEvent = () => {
    //     window.scrollTo(x, y);
    //   };
    // //  window.addEventListener('onscroll', scrollEvent)
    //   // window.onscroll =
    // }
    if (result.page < result.nbPages) {
      setpage(prevState => prevState + 1);
      let itemFilter = _objectSpread(_objectSpread({}, stateFilters), {}, {
        page: page
      });
      getListing(indexName, itemFilter, algoliaSettings).then(response => {
        setnbPages(response.nbPages);
        setResult(response);
        setnbHits(response.nbHits);
        if (hits) {
          setHits(hits.concat(response.hits));
        } else {
          setHits(response.hits);
        }
      });
    }
  };
  const removeFav = id => {
    setOverlayButton(false);
    setparsedId(id.split('-').join(''));
    setOverlayButton(true);

    // setFilter()
    // setTimeout(() => {

    //   // setfavButtonState(parsedId);
    // }, 10);

    let timer = setTimeout(() => {
      removeItem(id.split('-').join(''));
      if (canUseDOM) {
        if (localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME) !== null) {
          items = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TOPPICKS_NAME));
        }
      }
      const objectId = get(items, 'list', []).map(item => {
        return `objectID:${item && item.itemId && item.itemId.split('-').join('')}`;
      }) || [];
      let itemFilter = _objectSpread(_objectSpread({}, stateFilters), {}, {
        facets: ['type'],
        facetFilters: [[...filterTypes], [...objectId]]
      });
      getListing(indexName, itemFilter, algoliaSettings).then(response => {
        // setnbPages(response.nbPages);
        // setResult(response);
        // if(!get(response,"facets.type.POI")){
        //   setpoiFilter(false)
        // }
        // if(!get(response,"facets.type.Article")){
        //   setarticleFilter(false)
        // }
        // if(!get(response,"facets.type.Event")){
        //   seteventFilter(false)
        // }
        // if(!get(response,"facets.type.Itineraries")){
        //   setitenaryFilter(false)
        // }
      });
      setOverlayButton(false);
      clearTimeout(timer);
    }, 2000);
    settimer(timer);
  };
  const removeItem = parsedId => {
    //
    const updatedHits = hits.filter(hit => {
      if (hit.objectID !== parsedId) {
        return hit;
      }
    });
    setTimeout(() => {
      if (updatedHits.length === 0) {
        if (filterRef.current.querySelectorAll('.fp__checkbox').length === 1) {
          setemptyError(true);
          filterRef.current.style.display = 'none';
        }

        // if (checkboxRef.current) {
        //   checkboxRef.current.style.display = 'none';
        // }
      }
    }, 10);
    setHits(updatedHits);
  };
  const {
    bannerClickAnalytics,
    titleClickAnalytics,
    navBubblesAnalytics,
    prevNextNavAnalytics,
    addToFavAnalytics,
    exploreMoreAnalytics,
    mobileSlidesAnalytics,
    seeMoreAnalytics,
    smallBannerClickAnalytics
  } = fields.data;
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  return /*#__PURE__*/React.createElement(ComponentsWrapper, null, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "row top-picks"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-9 offset-xl-1"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h3"
  }, YourTopPicksTitle), emptyError && /*#__PURE__*/React.createElement("p", {
    className: "top-picks__desc"
  }, errorMessage.split('##heart##')[0], " ", /*#__PURE__*/React.createElement("img", {
    className: "icon",
    alt: "icon",
    title: "icon",
    src: heartLine
  }), ' ', errorMessage.split('##heart##')[1]), /*#__PURE__*/React.createElement("div", {
    className: "filters"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select",
    ref: filterRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-checkbox g-checkbox--mob-scroll",
    ref: checkboxRef
  }, facets && facets.type && Object.keys(facets.type).map((item, index) => /*#__PURE__*/React.createElement(CheckBox, {
    item: item,
    key: index,
    index: index,
    label: checkboxLabelMap[item],
    checkboxRef: checkboxRef,
    setFilter: setFilter
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "common-listing-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row",
    style: {
      rowGap: '20px'
    }
  }, hits && hits.map((hit, index) => {
    if (hit.type[0] === 'POI') {
      return /*#__PURE__*/React.createElement("div", {
        // style={hit.objectID === removedId ? { display: 'none' } : {}}
        className: "poi-styles col-12 col-sm-6 col-md-4",
        onClick: () => {
          setremovedItemType(poiCopy);
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: " poi-item-col"
      }, /*#__PURE__*/React.createElement(POIBlock, {
        item: hit,
        callback: removeFav,
        curatorsCopy: curatorPick,
        hostLink: '',
        analytics: {
          bannerClickAnalytics,
          titleClickAnalytics,
          navBubblesAnalytics,
          prevNextNavAnalytics,
          addToFavAnalytics,
          exploreMoreAnalytics,
          mobileSlidesAnalytics,
          smallBannerClickAnalytics,
          params
        },
        dictionary: getDictionaryItem(dictionary, 'reviews') || ''
      })));
    }
    if (hit.type[0] === 'Restaurant') {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-sm-6 col-md-4",
        key: index
      }, /*#__PURE__*/React.createElement(RestaurantsCard, {
        params: params,
        item: hit,
        reviews: getDictionaryItem(dictionary, 'reviews') || '',
        rtl: rtl,
        isGetFullUrl: true
      }));
    }
    if (hit.type[0] === 'Event') {
      return /*#__PURE__*/React.createElement("div", {
        className: "event-styles col-3 col-12 col-sm-6 col-md-4",
        onClick: () => {
          setremovedItemType(eventCopy);
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: " events-item-col-outer"
      }, /*#__PURE__*/React.createElement(EventBlock, {
        userProfile: userProfile,
        event: hit,
        curatorsCopy: curatorPick,
        callback: removeFav,
        lang: currentLang,
        hostLink: '',
        analytics: {
          titleClickAnalytics,
          bannerClickAnalytics,
          addToFavAnalytics,
          seeMoreAnalytics,
          eventsAnalytics,
          smallBannerClickAnalytics,
          params
        },
        countryItems: countryItems,
        themeValues: [selectedPrimaryColor, getColorByTheme(selectedPrimaryColor)]
      })));
    }
    if (hit.type[0] === 'Article') {
      return /*#__PURE__*/React.createElement("div", {
        className: "article-styles col-12 col-sm-6 col-md-4",
        onClick: () => {
          setremovedItemType(articleCopy);
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: " article-item-col "
      }, /*#__PURE__*/React.createElement(ArticleBlock, {
        item: hit,
        copyBy: byCopy,
        copyMinread: MinRead,
        callback: removeFav,
        lang: currentLang,
        hostLink: '',
        analytics: {
          eventsAnalytics,
          params
        }
      })));
    }
  }), hits && hits.map((hit, index) => {
    if (hit.type[0] === 'Itineraries') {
      return /*#__PURE__*/React.createElement("div", {
        className: "col-12",
        onClick: () => {
          setremovedItemType(itineraryCopy);
        },
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: " itinerary-styles col-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-featured"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-container__row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-main-container"
      }, /*#__PURE__*/React.createElement(ItenaryBlock, {
        item: hit,
        day: day,
        callback: removeFav,
        curatorsCopy: curatorPick,
        days: days,
        hostLink: '',
        analytics: {
          bannerClickAnalytics,
          titleClickAnalytics,
          navBubblesAnalytics,
          prevNextNavAnalytics,
          addToFavAnalytics,
          exploreMoreAnalytics,
          mobileSlidesAnalytics,
          seeMoreAnalytics,
          params
        }
      })))))))));
    }
  }), /*#__PURE__*/React.createElement(RemoveButtonOvelray, null))))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-9 offset-xl-1"
  }, hits && nbPages > page && /*#__PURE__*/React.createElement(LoadMore, {
    buttonLabel: LoadMoreCopy,
    onClick: loadMore,
    nbHits: nbHits,
    loadedHits: hits && hits.length,
    viewedNofMLabel: viewedNofMLabel
  })))));
};
const globalStyles = "g12pusza";
export const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles}  ${eventStyle} ${poiStyle} ${globalStyles} ${articleStyle} ${itemStyles} ${loadMoreButtonStylesLtr} ${filterStyle} ${curatorltrStyles} ${curatorStyle} ${topPicksStyles} ${rtl ? curatorRtlStyles : curatorltrStyles} ${rtl ? stylesRTL : stylesLTR}  ${rtl ? stylesSpecificRTL : stylesSpecificLTR}  `
  }, children);
};
const topPicksStyles = "tb0jwc3";
const stylesSpecificLTR = "sopke6e";
const stylesSpecificRTL = "soutc48";
export default TopPicks;